import { render, staticRenderFns } from "./CalendarResources.vue?vue&type=template&id=3b13133f&scoped=true"
import script from "./CalendarResources.vue?vue&type=script&lang=ts"
export * from "./CalendarResources.vue?vue&type=script&lang=ts"
import style0 from "./CalendarResources.vue?vue&type=style&index=0&id=3b13133f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13133f",
  null
  
)

export default component.exports